import { useChatbotSession } from 'features/chatbot/contexts/ChatbotSessionContext'
import React from 'react'
import styled from 'styled-components'

import { SessionPaneContent } from './SessionPaneContent'

const PanesContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`

/**
 * Renders all open sessions simultaneously. Inactive panes are hidden
 * via CSS so their data layers, AI event handlers, and feedback providers
 * stay mounted (preserving in-flight streaming and unsaved feedback).
 */
export const SessionDataBridge: React.FC<{ legacyAutoScroll?: boolean }> = ({
  legacyAutoScroll = false,
}) => {
  const { openSessions, activeSession } = useChatbotSession()

  return (
    <PanesContainer>
      {openSessions.map((session) => (
        <SessionPaneContent
          key={session.id}
          session={session}
          isActive={session.id === activeSession.id}
          legacyAutoScroll={legacyAutoScroll}
        />
      ))}
    </PanesContainer>
  )
}
